import { createElementBlock as e, openBlock as l, createElementVNode as o } from "vue";
const V = {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-digitalformat"
};
function i(n, t) {
  return l(), e("svg", V, t[0] || (t[0] = [
    o("path", {
      d: "M13.5 0.799988H16.2C17.19 0.799988 18 1.60999 18 2.59999V4.39999H16.2V2.59999H13.5V0.799988ZM1.8 4.39999V2.59999H4.5V0.799988H1.8C0.81 0.799988 0 1.60999 0 2.59999V4.39999H1.8ZM16.2 11.6V13.4H13.5V15.2H16.2C17.19 15.2 18 14.39 18 13.4V11.6H16.2ZM4.5 13.4H1.8V11.6H0V13.4C0 14.39 0.81 15.2 1.8 15.2H4.5V13.4ZM12.6 6.19999V9.79999H5.4V6.19999H12.6ZM14.4 4.39999H3.6V11.6H14.4V4.39999Z",
      fill: "#555555",
      class: "svg__fill--medium-grey"
    }, null, -1)
  ]));
}
const r = { render: i };
export {
  r as default,
  i as render
};
